import React, {Component} from 'react';
import CarTypeField from "./CarTypeField";
import AllCarTypeField from "./AllCarTypeField";
import {withRouter} from "react-router-dom";

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {faSpinner} from '@fortawesome/fontawesome-free-solid'

import styled from 'styled-components';
import {connect} from "react-redux";
import {apiFetchFilterCarModelClass, apiGetBanner, apiFetchFilterCarModelClassNew, apiFetchFilterCarModelClassNewParams, apiFetchModelClassTypes, apiFetchModelClassTypesNew, apiFetchCarModelClassList} from "../../apis/calculator";
import {withErrorHandler} from "../../errors/ErrorHandler";
import {fetchModelClassTypes} from "../../actions/calculator";
import routeHelper from "../../helpers/RouteHelper";
import currencyHelper from '../../helpers/CurrencyHelper';
import LoadingLayer from "../LoadingLayer";

import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import ReactPixel from 'react-facebook-pixel';
import AlertBox from '../AlertBox';


const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);
const Handle = Slider.Handle;
const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

const CarModelPageDiv = styled.div`
.label-wrap {
  cursor: default;
  display: inline-block;    
  position: absolute;
  left: 0;
  margin-left: 37px;
  margin-top: -36px;

  padding: 7px 15px;
  border-radius: 1.25rem;
  background-color: #101010;
  color: #FFF;

  font-size: 12px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  font-weight: bold;

  @media (max-width: 420px) {
    position: relative;
    display: inline-block;
    margin-left: 0;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.textInfo {
  letter-spacing: 2.7px;
  font-size: 18px !important;

  @media (max-width: 420px) {
    margin-top: 20px !important;
  }
}
.textInfo, .textInfoPayment{
    text-align:center;
    font-size:1.4rem;
    color:#333;
    font-family:'MazdaM',Helvetica, sans-serif;
    margin: 20px 0 0 0;
    max-width: calc(100% - 16px);
}
.textInfoPayment{
    margin-top:2pt;
    color:#a4a4a4;
    font-size:16px;
}
.typeText{
    flex: 1;
    font-size: 14px;
    color:#000000;
    font-family: sans-serif;
    margin-top: 10px;
}

.termsContainer {
    height: 32px;
    border: 1px #ddd solid;
    line-height: 32px;
    border-radius: 2px;

}

.termsContainer li:not(:last-child) {
    border-right: 1px #ddd solid;
}

.car__model__filters {
    /* max-width: calc(768px - 2 * 56.5px); */
    max-width: 100%;
    margin: 0 auto;
    width: 100%;
    display: block;
    overflow: hidden;
    height: auto;
    text-align: center;
    padding-left: 15px;
    padding-right: 15px;
}

.paymentTermOptionItem {
    padding-left: 10px;
    padding-right: 10px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
}

.paymentTermOptionItemInactive {
    /*background-color: #a4a4a4;*/
    color: #a4a4a4;
}

.model__image__container {
  width: 100%;
}

.modelImage {
    margin: 0 auto;
    max-width: 310px;
    height: 225px;
    align-content: center;
    position: relative;
    
    .image {
      cursor: pointer;
      
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      
      z-index: 0;
      width: 100%;
      height: 225px;
    }
}

.modelDesc {
    cursor: pointer;
    width: 100%;
    font-family:'Mazda',Helvetica, sans-serif;
    font-size: 1.5rem;
    color:#000000;
    margin-top: 1.5px;
    text-align: center;
}

.no-records {
  font-size: 24px;
  background: rgba(0,0,0,0.1);
  display: flex;
  height: 100px;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.installmentPrice {
  font-family: 'Mazda',Helvetica, sans-serif;
  font-size: 1rem;
}

.variantLabel {
  display: inline-block;
  margin-top: 10px;
  font-size: 18px;
}

.container {
     min-height: 100vh;
     height: 100%;
     padding: 1rem;
}

.rangeWrap {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  @media (max-width: 600px) {
    max-width: calc(100% - 30px);
  }
}

/* fallback styles */
.grid {
     display: flex;
     flex-flow: row wrap;
}

.grid--gutter-small {
     margin-left: -1rem;
}

.grid__item {
     flex: 1 0 auto;
     padding-left: 1rem;
     padding-bottom: 1rem;
     width: 300px; 
}
/* end fallback styles */

@supports (display: grid) {
     .grid {
          display: grid;
          display: -ms-grid;
     }
     
     /* resets */
     .grid__item {
          padding: initial;
          width: auto;
     }
     
     .grid--gutter-small {
          margin: initial;
     }
}

.grid--gutter-small {
     grid-gap: 1rem;
}

.grid--auto-sizing {
      -ms-grid-columns: repeat(auto-fit, minmax(300px, 1fr)); 
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));        
     @media (max-width: 647px){
      grid-template-columns: repeat(auto-fit, minmax(300px));
      -ms-grid-columns: repeat(auto-fit, minmax(300px));
     }
}

.shared-switch-wrap {
  margin-bottom: 0;
  position: relative;
  width: 136px;
  height: 31px;
  border-radius: 1.25rem;
  border: 0.125rem solid #999999;
  color: #999999;

  font-size: 1.5rem;

  div {
      display: inline-block;
  }

  input {
      opacity: 0;
      width: 0;
      height: 0;
  }
}

.shared-switch-option-left {
  float: left;
}

.shared-switch-option-right {
  float: right;
}

.shared-switch-option-left, .shared-switch-option-right {
  z-index: -1;
  width: 50%;
  border-radius: 1.25rem;
  cursor: pointer;
  text-align: center;
  padding-top: 7px;
}

.shared-switch-option-left.active, .shared-switch-option-right.active {
  color: #FFF;
}

.shared-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 1.25rem;
}

.shared-switch-slider:before {
  left: -0.125rem;
  bottom: -0.125rem;
  position: absolute;
  content: "";
  background-color: #101010;
  width: 70px;
  height: 31px;
  border: 0.125rem solid #101010;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 1.25rem;
}

input:checked + .shared-switch-slider:before {
  width: 70px;
  -webkit-transform: translateX(93%);
  -ms-transform: translateX(93%);
  transform: translateX(93%);
}

.shared-switch-container {
  display: inline-block;    
  position: absolute;
  left: 0;
  margin-left: 37px;
  margin-top: -36px;

  @media (max-width: 420px) {
    position: relative;
    display: inline-block;
    margin-left: 0;
    margin-top: 20px;
    margin-bottom: 16px;
  }
}

.shared-switch-text-wrap {
  display: inline-block;
  width: 136px;
  height: 31px;
  left: 0;
  position: absolute;
  font-size: 12px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  font-weight: bold;
  color: #999999;
}
`

const NoneFound = styled.div`
  width: 100%;
  height: 100%;

  div {
    width: 100%;
    padding: 10px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    font-size: 25px;
    font-weight: bold;
  }

  span {
    @media (min-width: 1000px) {
      display: block;
    }
  }
`;

class CarModelPage extends Component {

  state = {
    bodyTypeOptions: [],
    listItems: [],
    selectedBodyTypes: null,
    selectedSeatingCapacities: 2,

    //slider 
    min: '',
    max: '',
    step: 1,
    value: [],
    defaultValue:[],
    initiate: false,
    demo: false,
    first: true,
    showDemo: false,
    showNew: false,
    initialLoad: true,
    paramsUnavailable: false,
    alertMsg: '',
    prod: false
  };
  
  componentDidMount() {

    if (window.location.href.includes("online-sales.mazda.com.sg")) {
      ReactPixel.init('273792070524054');
      ReactPixel.pageView();

      this.setState({
        prod: true
      })
    }

      let context = this.props.context;


      Promise.all([apiFetchModelClassTypesNew(context, !(this.state.demo))]).then(([r])=>{
        if (r && r.carModelClassList.length) {
          this.setState({
            showNew: true
          }, () => {
            this.applyFilters(r);

            if (this.props.match.params.id) {
              this.updateCarModelParams({
                [this.props.match.params.id.toUpperCase()]: true
              }, context);
    
            this.setState({
              selectedBodyTypes: {
                [this.props.match.params.id.toUpperCase()]: true
              },
              initiate: true
            })
          }
          })
        }
        this.setState({
          initialLoad: false
        })
      }).catch((e)=>{
        if(!this.props.errorHandler.handleError(e)) throw e;  
      });

      Promise.all([apiFetchModelClassTypesNew(context, false)]).then(([r])=>{
        if (r && r.carModelClassList.length) {
          this.setState({
            showDemo: true
          }, () => {
            if (this.state.showNew) {
              return
            }
              this.applyFilters(r);

              if (this.props.match.params.id) {
                this.updateCarModelParams({
                  [this.props.match.params.id.toUpperCase()]: true
                }, context);
      
              this.setState({
                selectedBodyTypes: {
                  [this.props.match.params.id.toUpperCase()]: true
                },
                initiate: true
              })
            }
          })

        }
        this.setState({
          initialLoad: false
        })
      }).catch((e)=>{
        if(!this.props.errorHandler.handleError(e)) throw e;
      });

      
      
  }

  toggleSwitchBox = () => {
    this.switchElement.click();
  }

  toggleSwitch = () => {
    let val = this.state.demo;

    this.setState({
      demo: !val,
      selectedBodyTypes: {value: true}
    }, () => {
      let context = this.props.context;
      Promise.all([apiFetchModelClassTypesNew(context, !(this.state.demo))]).then(([r])=>{
        this.applyFilters(r);
        this.setState({
          selectedBodyTypes: {value: true}
        })
      }).catch((e)=>{
        if(!this.props.errorHandler.handleError(e)) throw e;  
      });
    })
  }
  
  applyFilters(bodyTypes) {
    let bodyTypeOptions = bodyTypes.carModelClassList.map(i => ({value: i.modelClassId, label: i.modelClassCode}));
    let selectedBodyTypes = bodyTypes.carModelClassList.map(i => i.modelClassId).reduce((acc, item) => ({...acc, [item]: false}), {});
    selectedBodyTypes[9] = true;

    this.setState({

      bodyTypeOptions

    })

    if (!this.props.match.params.id) {
      this.setState({
        selectedBodyTypes
      })
    } 
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    let context = this.props.context;
    let conditionA = this.state.selectedBodyTypes != prevState.selectedBodyTypes;
    let conditionC = context != prevProps.context;

      if(
        conditionA ||
        conditionC) {

        if (this.props.match.params.id && this.state.first) {
          return
        }
  
        if(!this.state.selectedBodyTypes) {
          
          Promise.all([apiFetchModelClassTypesNew(context, (!this.state.demo))]).then(([r])=>{
            this.applyFilters(r);
          }).catch((e)=>{
            if(!this.props.errorHandler.handleError(e)) throw e;
          });
        }
        if(context.companyId && context.zoneId && this.state.selectedBodyTypes) {
          this.updateCarModel(this.state.selectedBodyTypes, context);
        }
      }
    
  }

  getBanner = (isNew, modelCode) => {
    Promise.all([apiGetBanner(isNew, modelCode)]).then(([r])=>{
      if (r) {
        this.setState({
          alertMsg: r
        });
      }
      else {
        this.setState({
          alertMsg: ''
        })
      }
    }).catch((e)=>{
      if(!this.props.errorHandler.handleError(e)) throw e;
    });
  }


  changeModel = (e) => {
    this.setState({
      selectedBodyTypes: e,
      initiate: true
    });
  }

  updateCarModelParams = (bodyTypeSelected, context) =>{
    
    const bodyTypes = this.state.bodyTypeOptions.filter(i=>bodyTypeSelected[i.value]).map(i=>encodeURIComponent(i.value));

    let isNew = !this.state.demo;
    if (!this.state.showDemo) {
      isNew = true;
    }

    if (!this.state.showNew) {
      isNew = false
    }

    this.getBanner(isNew, this.props.match.params.id);

    apiFetchFilterCarModelClassNewParams({context},isNew, this.props.match.params.id).then((r)=>{
      this.setState({
        first: false
      })
      if (!r.carVariantList.length) {
        this.setState({
          paramsUnavailable: true
        })
      }
      let carPrice = r.carVariantList;
      let carPriceOption = carPrice.map(i=>({value: i.carPrice, label: i.carPrice}));
      let selectedcarPriceOption = carPriceOption.map(i => i.value).reduce((acc, item) => ({
        ...acc,
        [item]: true
      }), {});
      let carValue = carPriceOption.map(i => i.value);
      let maxCarValue = Math.max(...carValue);
      let minCarValue = Math.min(...carValue);
      let value = [minCarValue, maxCarValue];

      let list = r.carVariantList;

      list.sort(function(a, b) {
        var modelClassLabelA = a.modelClassLabel
        var modelClassLabelB = b.modelClassLabel
        if (modelClassLabelA < modelClassLabelB) {
          return -1;
        }
        if (modelClassLabelA > modelClassLabelB) {
          return 1;
        }
      
        // names must be equal
        return 0;
      });

      // this.getBanner(isNew, this.props.match.params.id);

      this.setState({
        carPriceOption,
        selectedcarPriceOption,
        maxCarValue,
        minCarValue,
        min: minCarValue,
        max: maxCarValue,
        step: 1,
        value: value,
        carValue,
        
        listItems:list,

      });
    }).catch((e)=>{
      if(!this.props.errorHandler.handleError(e)) throw e;
    })
  }

  updateCarModel = (bodyTypeSelected, context) =>{
    
    const bodyTypes = this.state.bodyTypeOptions.filter(i=>bodyTypeSelected[i.value]).map(i=>encodeURIComponent(i.value));

    let isNew = !this.state.demo;

    if (!this.state.showDemo) {
      isNew = true;
    }

    if (!this.state.showNew) {
      isNew = false
    }

    let bannerParams = 'All';

    if (bodyTypes.length) {
      bannerParams = bodyTypes[0];
    }

    this.getBanner(isNew, bannerParams);

    apiFetchFilterCarModelClassNew({bodyTypes, context},isNew).then((r)=>{
      let carPrice = r.carVariantList;
      let carPriceOption = carPrice.map(i=>({value: i.carPrice, label: i.carPrice}));
      let selectedcarPriceOption = carPriceOption.map(i => i.value).reduce((acc, item) => ({
        ...acc,
        [item]: true
      }), {});
      let carValue = carPriceOption.map(i => i.value);
      let maxCarValue = Math.max(...carValue);
      let minCarValue = Math.min(...carValue);
      let value = [minCarValue, maxCarValue];

      let list = r.carVariantList;

      list.sort(function(a, b) {
        var modelClassLabelA = a.modelClassLabel
        var modelClassLabelB = b.modelClassLabel
        if (modelClassLabelA < modelClassLabelB) {
          return -1;
        }
        if (modelClassLabelA > modelClassLabelB) {
          return 1;
        }
      
        // names must be equal
        return 0;
      });

      this.setState({
        carPriceOption,
        selectedcarPriceOption,
        maxCarValue,
        minCarValue,
        min: minCarValue,
        max: maxCarValue,
        step: 1,
        value: value,
        carValue,
        
        listItems:list,

      });
    }).catch((e)=>{
      if(!this.props.errorHandler.handleError(e)) throw e;
    })
  }

  onCarModelItemClicked = (model) => {
    let prefix = '';
    let modelClassId = model.modelClassId;
    let modelClassTypeId = model.modelClassTypeId;
    let id = model.id
    this.props.initializeCalculator(modelClassId,modelClassTypeId, id);
   //this.props.history.push(`${routeHelper.urlPrefixForZone(this.props.context)}/calculator/car-model/${modelClassId}`);
    this.props.history.push(`${prefix}/calculator/${encodeURIComponent(modelClassTypeId)}/${encodeURIComponent(modelClassId)}/${encodeURIComponent(id)}`);
  }

  onSliderChange = (value) => {
    this.setState({
      value,
      defaultValue:[value[0], value[1]]
      // defaultValue: [this.state.min, this.state.max]
      //defaultValue:[54900,64900]
    });
  }

  render() {
    const {min, max, step, value, selectedcarPriceOption, demo} = this.state;
    let setContainerWidth = this.state.listItems.length == '2' ? '900px' : '1600px';
    if(this.state.min == this.state.max){
       var status = true;
    }
    const sameVal = status;

    if (this.state.listItems.length == '0' || this.state.paramsUnavailable) {
      if ((!this.state.showDemo && !this.state.showNew && !this.state.initialLoad) || this.state.paramsUnavailable) {
        return <NoneFound>
          <div>
          Thank you for your interest, our showroom display cars promotion has ended. <span>Stay tuned for future promotions!</span>
          </div>
          </NoneFound>
      }
      else {
        return <LoadingLayer/>
      }
    }
    
    return <CarModelPageDiv>
      {
        this.state.alertMsg ? <AlertBox alertTxt={this.state.alertMsg} /> : ''
      }
      {
        this.state.prod ? <img style={{width: 0, height: 0, position: "absolute"}} border="0" src="https://r.turn.com/r/beacon?b2=zV_mSPPBT-oh2KX1Be1jQQZtfpEh8i6_MCyURTj3DVazNPlUFo4chDo95bs8J6m4e1C6jOXTjjU5NrrXXiKG_g&cid=" /> : ''
      }
      <div className={'car__model__filters'}>
        <div className={'textInfo'}>
          <span className={'textInfo'}>CHOOSE YOUR MAZDA</span>
        </div>
  
        {
          // false ?
          this.state.showDemo  && this.state.showNew ? 
          <div className="shared-switch-container">
              <label className="shared-switch-wrap">
                  <input type="checkbox" ref={i => this.switchElement = i} checked={this.state.demo} onChange={() => this.toggleSwitch()} />
                  <span className="shared-switch-slider"></span>
              </label>
              <div className="shared-switch-text-wrap" onClick={() => this.toggleSwitchBox()}>
                  <div className={!this.state.demo ? "shared-switch-option-left active" : "shared-switch-option-left"}>
                      New
                  </div>
                  <div className={this.state.demo ? "shared-switch-option-right active" : "shared-switch-option-right"}>
                      Demo
                  </div>
              </div>
          </div> : ''
        }
        {
          // true ?
          this.state.showDemo && !this.state.showNew ?
          <div className="label-wrap">
            Demo
          </div> : ''
        }
        {
          this.state.showNew && !this.state.showDemo ?
          <div className="label-wrap">
            New
          </div> : ''
        }
      </div>
      
        <div className="text-center">
        <CarTypeField
              options={this.state.bodyTypeOptions}
              value={this.state.initiate ? this.state.selectedBodyTypes : {value: true}}
              onChange={
                e => this.changeModel(e)}
            />
        </div>

      <div style={{maxWidth: setContainerWidth}} className={'container container-fluid'}>
        
        <div className="grid grid--gutter-small grid--auto-sizing">
              
              { 
                this.state.listItems.filter((i, key) => {
                  return ((i.carPrice >= value[0]) && (value[1] >=i.carPrice)) 
                }).map ( (i,key) => {
                  return <CarModelItem className={'grid  grid__item'} demo={demo} showDemo={this.state.showDemo} showNew={this.state.showNew}  key={key} carModel={i}/>
                })
              }

              {
                this.state.listItems.length < 1 && <div className={'no-records col-12'}>
                  No car model found for your criteria
                </div>
              }
        </div>
      </div>
    </CarModelPageDiv>
  }

}


class CarModelItem extends Component{
  state={value:0}

  clickModel(){
    //this.props.onCarModelItemClicked(this.props.carModel);
    let prefix = '';
    let id = this.props.carModel.id, 
      isNew = !(this.props.demo);

    if (!this.props.showDemo) {
      isNew = true;
    }

    if (!this.props.showNew) {
      isNew = false
    }
   //this.props.history.push(`${routeHelper.urlPrefixForZone(this.props.context)}/calculator/car-model/${modelClassId}`);
    this.props.history.push(`${prefix}/calculator/${encodeURIComponent(id)}/${isNew}`);

  }
  componentWillReceiveProps(nextProps){
    this.setState({value:nextProps.value})

  }

  
  render(){
    return (
      <div className={' '+ this.props.className}>
        <div className={'model__image__container'}>
          <CarImage onClick={e=>this.clickModel()} coverImage={this.props.carModel.coverImage} />
        </div>
        <div className={'modelDesc'}>
          <CarDesc onClick={e=>this.clickModel()} carModel={this.props.carModel} modelClass={this.props.modelClass} />
        </div>
      </div>
      
    );

  }
}

CarModelItem = withRouter(CarModelItem)

class CarImage extends Component{
  render() {
    return (
      <div className={'modelImage'}>
        <img onClick={this.props.onClick} className={'image'}  src={ this.props.coverImage || ''} alt=""/>
      </div>

    );
  }
}

class CarDesc extends Component{

  render() {
    return (
      <span onClick={this.props.onClick} className={'modelDesc'}>
        {/*{this.props.carModel.modelClassBrand}/{this.props.carModel.modelClassTypeLabel}*/}
        <span className="variantLabel">{this.props.carModel.modelClassLabel + " " + this.props.carModel.variantLabel}</span>
        <p className={'installmentPrice'}>From {currencyHelper.formatCurrencyJP((this.props.carModel.carPrice))}</p>
            </span>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    context: state.context
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    initializeCalculator(carModelId,modelClassTypeId) {
      // dispatch()
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withErrorHandler(CarModelPage)));



// WEBPACK FOOTER //
// ./src/components/car-model-page/CarModelPage.js